import { render, staticRenderFns } from "./Question2.vue?vue&type=template&id=dd5e7442&scoped=true&"
import script from "./Question2.vue?vue&type=script&lang=js&"
export * from "./Question2.vue?vue&type=script&lang=js&"
import style0 from "./Question2.vue?vue&type=style&index=0&id=dd5e7442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5e7442",
  null
  
)

export default component.exports